import { inject, Injectable, signal } from '@angular/core';
import { CommonHttpService } from '../../common-http.service';
import { catchError, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { ISearchesDTO } from '../../../models/ISearchesDTO';

@Injectable({
  providedIn: 'root'
})
export class MySearchesService {

  private httpService = inject(CommonHttpService);
  private oidcSecurityService = inject(OidcSecurityService);
  private http = inject(HttpClient);


  mySearchesListSignal = signal<ISearchesDTO[] | null>(null);

  constructor() { }

  public getMySearches(): Observable<ISearchesDTO[]> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/searches`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {

        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);

          return this.httpService.get<ISearchesDTO[]>(url, undefined, headers);
        } else {
          return throwError(() => new Error('User is not authenticated'));
        }
      }),
      tap(response => {
        this.mySearchesListSignal.set(response);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );
  }

  putSearchEmailAlert(search: ISearchesDTO): Observable<string> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/searches/${search.id}/email-alerts`;

    const bodyString = `shouldReceive=${JSON.stringify(search.receiveEmail)}`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${authResult.accessToken}`)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');

          return this.httpService.put<string>(url, bodyString, undefined, headers);
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      }),
      tap(response => {
        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );
  }

  deleteSearch(itemId: number): Observable<string> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/searches/${itemId}`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${authResult.accessToken}`)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');
          return this.httpService.delete<string>(url, null, undefined, headers);
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      }),
      tap(response => {

      })
    );
  }

  postMySearch(q: string): Observable<string> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/searches`;

    const body = new HttpParams().set('query', q);

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(auth => {
        if (!auth.isAuthenticated) {
          return throwError(() => new Error('User not authenticated'));
        }

        const headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Accept', 'application/json')
          .set('Authorization', `Bearer ${auth.accessToken}`);

        return this.http.post<string>(url, body.toString(), {
          headers,
          responseType: 'text' as 'json'
        });
      })
    );
  }


}


